import { useState, useEffect } from "react";
import { useAppConfig } from "../context/AppConfigContext";

const ROTATION_INTERVAL = 6000;
const FADE_DURATION = 600;

export default function useStoryGreetings(name = "friend") {
  const { config } = useAppConfig();
  const storySets = config?.greetings?.storySets || [];

  const [storyIndex, setStoryIndex] = useState(0);
  const [messageIndex, setMessageIndex] = useState(0);
  const [visibleMessage, setVisibleMessage] = useState("");
  const [showGreeting, setShowGreeting] = useState(true);

  useEffect(() => {
    if (!storySets.length) return;

    const currentStory = storySets[storyIndex];
    const messageTemplate = currentStory?.messages?.[messageIndex];

    // ✅ Safely personalize the message
    const personalized =
      messageTemplate?.replace("{{name}}", name || "friend") || "";

    // ✅ Set visible message
    setVisibleMessage(personalized);

    // Animation timers
    const fadeOut = setTimeout(
      () => setShowGreeting(false),
      ROTATION_INTERVAL - FADE_DURATION
    );
    const rotate = setTimeout(() => {
      const nextMessage = (messageIndex + 1) % currentStory.messages.length;
      const nextStory =
        nextMessage === 0 ? (storyIndex + 1) % storySets.length : storyIndex;

      setMessageIndex(nextMessage);
      setStoryIndex(nextStory);
      setShowGreeting(true);
    }, ROTATION_INTERVAL);

    return () => {
      clearTimeout(fadeOut);
      clearTimeout(rotate);
    };
  }, [storySets, messageIndex, storyIndex, name]);

  return {
    visibleMessage,
    showGreeting,
    key: `${storyIndex}-${messageIndex}`,
  };
}
